import styled from 'styled-components'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

export const PageContainer = styled(DefaultContainer)`
	position: relative;
`
